// extracted by mini-css-extract-plugin
export default {"head":"header_head__TnKRr"};